module.exports = __webpack_public_path__ + "img/book.fd861686.svg";